module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-white.e6dde679.svg";